// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"594":"about","952":"activities"}[chunkId] || chunkId) + "." + {"574":"85e2e768","594":"1c8938cc","952":"393b2281"}[chunkId] + ".js";
};